import React from "react";
import ReactDOM from "react-dom";
// import "./index.css";

import reducers from "./reducer";
import middleware from "./middleware";
// import Routes from "./routes";
import { createStore } from "redux";
import { Provider } from "react-redux";
// import reportWebVitals from "./reportWebVitals";
import App from "./App";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
const store = createStore(reducers, middleware);
console.log(store, "the store is ");

const provider = (
  <Provider store={store}>
    <App />
  </Provider>
);
ReactDOM.render(provider, document.getElementById("root"));

// serviceWorkerRegistration.register();
// reportWebVitals();
